/****************************************************
 * Module Name:  customerFTPsettingsProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CustomerAPISettingsProxy {
    static GetSingleCustomerAPIsettingsById = (customerId, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/customerapi/${customerId}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CreateOrUpdateCustomerAPIsettings = (customerApisettingsData, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/customerapi/update`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(customerApisettingsData),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckCustomerApiEnabled = (userid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/customerapi/${userid}/api-enabled`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}